

  <div class="modal-header">
    <p class="modal-title">Detalles de actividad de {{trabajador.nombre}}</p>
    <button type="button"  class="close btn-sm" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  
  <div class="modal-body">
   
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->  
  
    <div class="card" *ngIf="actividadSeleccionada == 'TRABAJO EN ALTURAS' ">
      <div class="card-header" color="azul">TRABAJO EN ALTURAS</div>
      <div class="card-content">
  
        <div>
  
          <div class="row">
            <div class="col">
              <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
              <p><small>{{trabajoenalturas.descripcionTarea}}</small></p>
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <div>
                <p><small><strong>Fecha de vencimiento de la CERTIFICACIÓN de trabajo en alturas del trabajador:</strong></small></p>
                <p><small>{{ trabajoenalturas.vencimientoCertAlturas}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p><small><strong>Certificado de trabajo en alturas</strong></small></p>
                <div *ngIf="trabajoenalturas.urlCertificado == '' " >
                  <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
                </div>
                <div *ngIf="trabajoenalturas.urlCertificado != '' ">
                  <a  class="btn btn-outline-info btn-sm" role="button"  target="_blank"  [href]="trabajoenalturas.urlCertificado" ><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
                </div>
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <p><small><strong>Máxima altura en la cual se va a realizar la actividad:</strong></small></p>
              <p><small>{{trabajoenalturas.alturamaxima}}</small></p>
              
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <div>
                <p> <small><strong>Fecha de vencimiento del certificado médico de aptitud ocupacional</strong></small></p>
                <p><small>{{ trabajoenalturas.vencimientoCertMedico}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p> <small><strong>Certificado médico de aptitud ocupacional</strong></small></p>
                <div *ngIf="trabajoenalturas.urlCertificadoMedico == '' ">
                  <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
               </div>
                <div *ngIf="trabajoenalturas.urlCertificadoMedico != '' ">
                  <a  class="btn btn-outline-info btn-sm" role="button"  [href]="trabajoenalturas.urlCertificadoMedico" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p><small><strong>Nombre de la persona que solicitó el servicio</strong></small></p>
                <p><small>{{trabajoenalturas.solicitante}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p><small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
                <p><small>{{trabajoenalturas.lineaAaislar}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p><small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
                <p><small>{{trabajoenalturas.barrerasFisicas}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p><small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
                <p><small>{{trabajoenalturas.actividadesTraslapantes}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p><small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
                <p><small>{{trabajoenalturas.controlesManos}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p><small><strong>Síntomas respiratorios declarados:</strong></small></p>
                <p><small>{{trabajoenalturas.sintomas}}</small></p>
  
              </div>
            </div>
            <div class="col">
              <div>
                <p><small><strong>Elija las opciones que apliquen en su caso sobre la pregunta anterior</strong></small></p>
                <p><small>{{trabajoenalturas.situaciones}}</small></p>
  
              </div>
            </div>
          </div>
          
  
        </div>
  
      
        </div>
      
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'TRABAJO EN CALIENTE' ">
      <div class="card-header">TRABAJO EN CALIENTE</div>
      <div class="card-content">
  
        <div>
          <div class="row">
            <div class="col">
              <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
              <p><small>{{trabajoencaliente.descripcionTarea}}</small></p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p> <small><strong>Medidas de prevención que se tomarán para realizar la actividad en áreas con almacenamiento de sustancias inflamables o que previamente contenían sustancias inflamables</strong></small></p>
                <p><small>{{trabajoencaliente.medidasPrevencion}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p> <small><strong>¿La ubicación del área de trabajo se clasifica como área C1, División 1 y/o División 2?</strong></small></p>
                <p><small>{{trabajoencaliente.areadetrabajo}}</small></p>
                
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p> <small><strong>Resultados del monitoreo de atmósferas antes y durante:</strong></small></p>
                <p><small>{{trabajoencaliente.resultadosMonitoreo}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p> <small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
                <p><small>{{trabajoencaliente.lineaAaislar}}</small></p>
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <div>
                <p> <small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
                <p><small>{{trabajoencaliente.barrerasFisicas}}</small></p>
              </div>
            </div>
            <div class="col">
              <div>
                <p> <small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
                <p><small>{{trabajoencaliente.actividadesTraslapantes}}</small></p>
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <div>
  
                <p> <small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
                <p><small>{{trabajoencaliente.controlesManos}}</small></p>
  
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <p> <small><strong>Síntomas respiratorios</strong></small></p>
                <p><small>{{trabajoencaliente.sintomas}}</small></p>
  
              </div>
            </div>
            <div class="col">
              <div>
                <p>Elija las opciones que apliquen en su caso sobre la pregunta anterior</p>
                <p><small>{{trabajoencaliente.situaciones}}</small></p>
                <!--  -->
              </div>
            </div>
          </div>
  
        </div>
  
      
        
       
        
        </div>
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'LEVANTAMIENTO MECÁNICO' ">
      <div class="card-header">LEVANTAMIENTO MECÁNICO</div>
      <div class="card-content">
        
          <div>
            <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
            <p><small>{{levantamientomecanico.descripcionTarea}}</small></p>
          </div>
        
        <div>
          <p> <small><strong>Fecha de vencimiento de la CERTIFICACIÓN de operador o aparejador de izajes de carga:</strong></small></p>
          <p><small>{{levantamientomecanico.vencimientoCertMeca}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Certificado para izaje o aparejamiento</strong></small></p>
          <div *ngIf="levantamientomecanico.urlCertificadoIzaje == '' ">
            <p stacked>Certificado de trabajo en izaje:</p>
            <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
          </div>
          <div *ngIf="levantamientomecanico.urlCertificadoIzaje != '' ">
            <p stacked>Certificado de trabajo en izaje</p>
            <a   size="small" [href]="levantamientomecanico.urlCertificadoIzaje" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
            
          </div>
        </div>
  
        <div>
            <p> <small><strong>¿El plan de izaje es inferior al 70% de la capacidad total del equipo Respuesta?</strong></small></p>
            <p><small>{{levantamientomecanico.plandeizaje70}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
            <p><small>{{levantamientomecanico.lineaAaislar}}</small></p>
         
        </div>
        <div>
          <p> <small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
          <p><small>{{levantamientomecanico.barrerasFisicas}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
          <p><small>{{levantamientomecanico.actividadesTraslapantes}}</small></p>
        </div>
        <div>
          <p> <small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
          <p><small>{{levantamientomecanico.controlesManos}}</small></p>
        </div>
        <div>
          <p> <small><strong>Síntomas respiratorios</strong></small></p>
          <p><small>{{levantamientomecanico.sintomas}}</small></p>
        </div>
        <div>
          <p> <small><strong>Elija las opciones que apliquen en su caso sobre la pregunta anterior</strong></small></p>
          <p><small>{{levantamientomecanico.situaciones}}</small></p>
        </div>
        
  
        
        
        </div>
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'ENERGÍAS PELIGROSAS' ">
      <div class="card-header">ENERGÍAS PELIGROSAS</div>
      <div class="card-content">
        <div>
          <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
          <p><small>{{energiaspeligrosas.descripcionTarea}}</small></p>
        </div>
  
        <div>
            <p> <small><strong>¿El trabajo requiere intervención de energía eléctrica?</strong></small></p>
            <p><small>{{energiaspeligrosas.intervencionElectrica}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Número de certificación CONTE o Tarjeta Profesional.</strong></small></p>
          <p><small>{{energiaspeligrosas.certCONTE}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Certificación CONTE o Tarjeta Profesional</strong></small></p>
          <div *ngIf="energiaspeligrosas.urlCertCONTE == '' ">
            <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
          </div>
          <div *ngIf="energiaspeligrosas.urlCertCONTE != '' ">
            <a   size="small" [href]="energiaspeligrosas.urlCertCONTE" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
          </div>
        </div>
        <div>
          <p> <small><strong>Tipo de energías que va a intervenir</strong></small></p>
          <p><small>{{energiaspeligrosas.tipoDeEnergias}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>liste los equipos que debe aterrizar (Polo a tierra)</strong></small></p>
          <p><small>{{energiaspeligrosas.equiposAterrizar}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>liste los equipos que requiere bloquear</strong></small></p>
          <p><small>{{energiaspeligrosas.equiposABloquear}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Diligencie los resultados obtenidos en el monitoreo de energías peligrosas luego de desenergizar</strong></small></p>
          <p><small>{{energiaspeligrosas.equiposABloquear}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
          <p><small>{{energiaspeligrosas.lineaAaislar}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
          <p><small>{{energiaspeligrosas.barrerasFisicas}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
          <p><small>{{energiaspeligrosas.actividadesTraslapantes}}</small></p>
        </div>
        <div>
          <p> <small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
          <p><small>{{energiaspeligrosas.controlesManos}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Síntomas respiratorios</strong></small></p>
          <p><small>{{energiaspeligrosas.sintomas}}</small></p>
        </div>
        <div>
          <p> <small><strong>Elija las opciones que apliquen en su caso sobre la pregunta anterior</strong></small></p>
          <p><small>{{energiaspeligrosas.situaciones}}</small></p>
        </div>
  
  
  
        
        </div>
    </div>
  
    <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'ESPACIOS CONFINADOS' ">
      <div class="card-header">ESPACIOS CONFINADOS</div>
      <div class="card-content">
  
        <div>
          <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
          <p><small>{{espaciosconfinados.descripcionTarea}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Soporte de entrenamiento o certificado</strong></small></p>
          <div *ngIf="espaciosconfinados.urlCertificadoConfinados == '' ">
            <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
          </div>
          <div *ngIf="espaciosconfinados.urlCertificadoConfinados != '' ">
            <p stacked>Certificado de trabajo en confinados</p>
            <a   size="small" [href]="espaciosconfinados.urlCertificadoConfinados" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
          </div>
        </div>
  
        <div>
          <p> <small><strong>Certificado de aptitud médica para trabajo en espacios confinados</strong></small></p>
          <div *ngIf="espaciosconfinados.urlCertificadoAptitudConfinados == '' ">
            <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
          </div>
          <div *ngIf="espaciosconfinados.urlCertificadoAptitudConfinados != '' ">
            <p> <small><strong>Certificado médico</strong></small></p>
            <a   size="small" [href]="espaciosconfinados.urlCertificadoAptitudConfinados" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
          </div>
        </div>
  
        <div>
          <p> <small><strong>Equipos con los que realizará el trabajo</strong></small></p>
          <p><small>{{espaciosconfinados.equipos}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Resultados obtenidos en el monitoreo de O2, oxígeno y sustancias peligrosas.</strong></small></p>
          <p><small>{{espaciosconfinados.monitoreoO2}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Certificado de inspección y calibración de los equipos</strong></small></p>
  
          <div *ngIf="espaciosconfinados.urlCertificadoEquiposConfinados == '' ">
            <p style="color: rgb(177, 22, 22);"><strong><small>Certificado no cargado</small></strong><span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></p>
          </div>
  
          <div *ngIf="espaciosconfinados.urlCertificadoEquiposConfinados != '' ">
            <p> <small><strong>Certificado equipos</strong></small></p>
            <a   size="small" [href]="espaciosconfinados.urlCertificadoEquiposConfinados" target="_blank"><span><bi name="cloud-arrow-down-fill" style="color: rgb(252, 252, 252);"></bi></span>Descargar</a > 
          </div>
  
        </div>
  
        <div>
          <p> <small><strong>Seleccione las opciones en las que tenga entrenamiento</strong></small></p>
          <p><small>{{espaciosconfinados.monitoreoO2}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
          <p><small>{{espaciosconfinados.lineaAaislar}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
          <p><small>{{espaciosconfinados.barrerasFisicas}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
          <p><small>{{espaciosconfinados.actividadesTraslapantes}}</small></p>
        </div>
        <div>
          <p> <small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
          <p><small>{{espaciosconfinados.controlesManos}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Síntomas respiratorios</strong></small></p>
          <p><small>{{espaciosconfinados.sintomas}}</small></p>
        </div>
        <div>
          <p> <small><strong>Elija las opciones que apliquen en su caso sobre la pregunta anterior</strong></small></p>
          <p><small>{{espaciosconfinados.situaciones}}</small></p>
        </div>
  
        
        </div>
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'HAZMAT' ">
      <div class="card-header">HAZMAT</div>
      <div class="card-content">
  
        <div>
          <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
          <p><small>{{hazmat.descripcionTarea}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Qué sustancias utilizará?</strong></small></p>
          <p><small>{{hazmat.sustanciasQuimicas}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Con qué elementos demarcará el área de trabajo?</strong></small></p>
          <p><small>{{hazmat.elementosDemarcacion}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿El personal cuenta con fichas de seguridad?</strong></small></p>
          <p><small>{{hazmat.fichasdeseguridad}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Las sustancias se encuentran rotuladas con identificación HMIS III / SGA y está acorde a la valoración de la(s) Hojas de Seguridad (MSDS)?</strong></small></p>
          <p><small>{{hazmat.sustanciasRotuladas}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿El área de trabajo contará con matriz de compatibilidad química?</strong></small></p>
          <p><small>{{hazmat.matrizCompatibilidad}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Con qué tipo de elementos cuenta para evitar derrames al realizar trasvase de sustancias?</strong></small></p>
          <p><small>{{hazmat.elementosTrasvase}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Qué elementos para atención de emergencias hay en el área de manipulación?</strong></small></p>
          <p><small>{{hazmat.elementosEmergencia}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Qué elementos para atención de emergencias hay en el área de manipulación?</strong></small></p>
          <p><small>{{hazmat.epp}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Para qué tipo de sustancias o químicos requerirá monitoreo de atmósferas?</strong></small></p>
          <p><small>{{hazmat.sustAMonitorear}}</small></p>
        </div>
        
        <div>
          <p> <small><strong>Diligencie los resultados obtenidos en el monitoreo de O2 y sustancias peligrosas</strong></small></p>
          <p><small>{{hazmat.monitoreoO2}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuál línea o fuente de energía requiere aislarse para realizar el trabajo de forma segura?</strong></small></p>
          <p><small>{{hazmat.lineaAaislar}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuáles son las barreras físicas o dobles barreras que requiere para realizar el trabajo?</strong></small></p>
          <p><small>{{hazmat.barrerasFisicas}}</small></p>
        </div>
        <div>
          <p> <small><strong>¿Cuál o cuáles actividades pueden traslaparse con otras tareas?</strong></small></p>
          <p><small>{{hazmat.actividadesTraslapantes}}</small></p>
        </div>
        <div>
          <p> <small><strong>Además de los guantes, ¿qué controles adoptará para no sufrir una lesión en manos?</strong></small></p>
          <p><small>{{hazmat.controlesManos}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>Síntomas respiratorios</strong></small></p>
          <p><small>{{hazmat.sintomas}}</small></p>
        </div>
        <div>
          <p> <small><strong>Elija las opciones que apliquen en su caso sobre la pregunta anterior</strong></small></p>
          <p><small>{{hazmat.situaciones}}</small></p>
        </div>
  
        
  
        </div>
    </div>
  
  
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'SUPERVISIÓN Y MONITOREO' ">
      <div class="card-header">SUPERVISIÓN Y MONITOREO</div>
      <div class="card-content">
  
        <div>
  
          <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
          <p><small>{{supervisionymonitoreo.descripcionTarea}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Va a ejecutar tareas de supervisión?</strong></small></p>
          <p><small>{{supervisionymonitoreo.tareasSupervision}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Cuenta con su CAP de bolsillo para el control del trabajo a su cargo?</strong></small></p>
          <p><small>{{supervisionymonitoreo.capBolsillo}}</small></p>
        </div>
  
        <div>
          <p> <small><strong>¿Conoce las reglas de oro de GTE y se compromete a hacerlas cumplir?</strong></small></p>
          <p><small>{{supervisionymonitoreo.reglasOro}}</small></p>
        </div>
  
        
        </div>
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
    <div class="card" *ngIf="actividadSeleccionada == 'OTROS' ">
      <div class="card-header">OTROS</div>
      <div class="card-content">
        <div>
  
          <p> <small><strong>Descripción de la tarea a realizar:</strong></small></p>
          <p><small>{{otros.descripcionTarea}}</small></p>
  
        </div>
  
        <div>
          <p> <small><strong>Actividad 1:</strong></small></p>
          <p><small>{{otros.actividad1}}</small></p>
        </div>
        <div>
          <p> <small><strong>Actividad 2:</strong></small></p>
          <p><small>{{otros.actividad2}}</small></p>
        </div>
        <div>
          <p> <small><strong>Actividad 3:</strong></small></p>
          <p><small>{{otros.actividad3}}</small></p>
        </div>
        <div>
          <p> <small><strong>Actividad 4:</strong></small></p>
          <p><small>{{otros.actividad4}}</small></p>
        </div>
  
        
        </div>
    </div>
  
  <!-- --------------------------------------------------------------------------------------- -->
  <!-- --------------------------------------------------------------------------------------- -->
  
</div>